import React, { createContext, useContext } from 'react';
import { create } from 'zustand';

import { EmaiThreadEntryViewerPresets, EmailThreadEntryViewerViews, InboxEntry } from '../types';

type InboxEntryPanelZustandStore = {
  inboxEntry: InboxEntry;
  setInboxEntry: (inboxEntry: InboxEntry) => void;
  emaiThreadEntryViewerPresets: EmaiThreadEntryViewerPresets;
  setEmaiThreadEntryViewerPresets: (emaiThreadlInboxEntry: EmaiThreadEntryViewerPresets) => void;
  setEmailThreadInboxEntry: (
    inboxEntry: InboxEntry,
    emaiThreadEntryViewerPresets: EmaiThreadEntryViewerPresets
  ) => void;
  clearPreselectedFile: () => void;
  clearInboxEntry: () => void;
  setEmaiThreadEntryViewerDefaultView: (defaultView: EmailThreadEntryViewerViews) => void;
};

const InboxEntryPanelContext = createContext<InboxEntryPanelZustandStore>(undefined);

const defaultEmaiThreadEntryViewerPresets = {
  defaultView: EmailThreadEntryViewerViews.EmailEntries,
  preselectedFile: null,
};

const useInboxEntryPanelStore = create<InboxEntryPanelZustandStore>((set) => ({
  inboxEntry: null,
  automation: {},
  setInboxEntry: (inboxEntry: InboxEntry) => {
    set(() => {
      return {
        inboxEntry,
      };
    });
  },
  emaiThreadEntryViewerPresets: { ...defaultEmaiThreadEntryViewerPresets },
  setEmaiThreadEntryViewerPresets: (emaiThreadEntryViewerPresets: EmaiThreadEntryViewerPresets) =>
    set(() => ({
      emaiThreadEntryViewerPresets,
    })),
  setEmaiThreadEntryViewerDefaultView: (defaultView: EmailThreadEntryViewerViews) =>
    set((state) => ({
      emaiThreadEntryViewerPresets: {
        ...state.emaiThreadEntryViewerPresets,
        defaultView,
      },
    })),
  setEmailThreadInboxEntry: (
    inboxEntry: InboxEntry,
    emaiThreadEntryViewerPresets: EmaiThreadEntryViewerPresets
  ) =>
    set(() => {
      return {
        inboxEntry,
        emaiThreadEntryViewerPresets,
      };
    }),
  clearPreselectedFile: () =>
    set((state) => ({
      emaiThreadEntryViewerPresets: {
        ...state.emaiThreadEntryViewerPresets,
        preselectedFile: null,
      },
    })),
  clearInboxEntry: () =>
    set(() => ({
      inboxEntry: null,
      emailInboxEntry: null,
      emaiThreadEntryViewerPresets: { ...defaultEmaiThreadEntryViewerPresets },
    })),
}));

export const InboxEntryPanelProvider = ({ children }) => {
  const store = useInboxEntryPanelStore();

  return (
    <InboxEntryPanelContext.Provider value={store}>{children}</InboxEntryPanelContext.Provider>
  );
};

export function useInboxEntryPanel() {
  const store = useContext(InboxEntryPanelContext);
  if (!store) {
    throw new Error('useInboxEntryPanel must be used within a InboxEntryPanelContext');
  }
  return {
    ...store,
  };
}
